import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {makeAutoObservable} from "mobx";
import {RefObject, useRef} from "react";

export interface ISecretGateController extends ViewController {
	readonly i18n: ILocalizationStore;
	readonly ref: RefObject<HTMLDivElement>;
}

@injectable()
export class SecretGateController implements ISecretGateController {
	private static _count = 0;
	public readonly ref = useRef<HTMLDivElement>(null);

	static get IS_SECRET_PASSED() {
		const IS_SECRET_ENABLED = Boolean(
			JSON.parse(process.env.REACT_APP_IS_SECRET_ENABLED || "false")
		);

		if (IS_SECRET_ENABLED) {
			return Boolean(JSON.parse(sessionStorage.getItem("isSecretPassed") || "false"));
		}

		return true;
	}

	constructor(@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore) {
		makeAutoObservable(this);
	}

	static handleSecretClick = () => {
		if (SecretGateController.IS_SECRET_PASSED) {
			return;
		}

		SecretGateController._count += 1;

		if (SecretGateController._count >= 10) {
			sessionStorage.setItem("isSecretPassed", "true");
			window.location.reload();
		}
	};

	init() {
		const element = this.ref?.current?.querySelector("text");

		if (element) {
			element.onclick = SecretGateController.handleSecretClick;
		}
	}
}
